const steps = [
  {
    num: "01",
    title: "ご予約",
    desc: "LINEまたは予約フォームからご希望の日時をお知らせください。初回の方はカウンセリング時間を含めてご予約いただきます。",
  },
  {
    num: "02",
    title: "カウンセリング",
    desc: "当日はまず15〜20分ほどのカウンセリング。体の状態・お悩み・目標をお聞きし、施術内容をご提案します。",
  },
  {
    num: "03",
    title: "施術",
    desc: "完全個室のプライベート空間でリラックスしながら施術を受けていただきます。途中でご要望があればお気軽にお伝えください。",
  },
  {
    num: "04",
    title: "アフターケアアドバイス",
    desc: "施術後は体の状態をフィードバック。自宅でできるセルフケアのアドバイスもお伝えします。次回のご予約も承ります。",
  },
];

export default function FirstTimers() {
  return (
    <section className="py-24 bg-[#faf8f2]">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-[#3a4a28]/50 text-xs tracking-[0.4em] mb-4">FIRST VISIT</p>
          <h2 className="font-serif text-3xl md:text-4xl text-[#2a2a1e] leading-tight">
            はじめてでも、<br />安心の流れ。
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, i) => (
            <div key={i} className="relative">
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-full w-full h-px bg-[#3a4a28]/20 z-0" style={{ width: "calc(100% - 2rem)", left: "calc(100% - 0.5rem)" }} />
              )}
              <div className="bg-white border border-[#e8e4d8] rounded-lg p-7 relative z-10 h-full">
                <div className="font-serif text-4xl text-[#3a4a28]/20 mb-4">{step.num}</div>
                <h3 className="font-serif text-base text-[#2a2a1e] mb-3 tracking-wide">
                  {step.title}
                </h3>
                <p className="text-[#6a6a5a] text-sm leading-loose tracking-wide">
                  {step.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-[#5a5a4a] text-sm leading-loose tracking-wide">
            ご不明な点はLINEやメールでお気軽にお問い合わせください。<br />
            丁寧にご対応いたします。
          </p>
        </div>
      </div>
    </section>
  );
}
